import { createFileRoute, redirect } from "@tanstack/react-router";

// Bellevue location page removed — permanently redirect to the locations hub.
export const Route = createFileRoute("/locations/washington/bellevue")({
  beforeLoad: () => {
    throw redirect({
      href: "/locations/",
      statusCode: 301,
    });
  },
});
